import React from "react";
import "../Components/AboutComponents/About.css";
import AboutBanner from "../Components/AboutComponents/AboutBanner";
import AboutSummary from "../Components/AboutComponents/AboutSummary";
import { Helmet } from "react-helmet";
const AboutUs = () => {
  return (
    <>
      <Helmet>
        {/* Meta tags */}
        <title>About Us | Sreehari Diamond Certification Lab</title>
        <meta
          name="description"
          content="Sreehari Diamond Laboratory is a trusted gemological lab in India offering expert diamond testing, certification, sealing, and hologram services."
        />
        <meta
          name="keywords"
          content="About us, Sreehari diamond laboratory, lab grown diamond certification, best diamond certification in india, Gemstone Identification Lab, Diamond, Gemological Laboratory, Diamond Testing Lab, Diamond Sealing service, Diamond Hologram Stickers, Hologram Stickers for Certificates, Best diamond online services"
        />
        {/* OG tags */}
        <meta
          property="og:title"
          content="About Us | Sreehari Diamond Certification Lab"
        />
        <meta
          property="og:description"
          content="Sreehari Diamond Laboratory is a trusted gemological lab in India offering expert diamond testing, certification, sealing, and hologram services."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://sreeharidiamondlab.com/about-us"
        />
        <meta
          property="og:image"
          content="https://sreeharidiamondlab.com/static/media/About-Us.84214f9030191013ed4e.webp"
        />
        <meta property="og:site_name" content="sreehari diamond laboratory" />
        {/* Twitter tags */}
        <meta
          name="twitter:title"
          content="About Us | Sreehari Diamond Certification Lab"
        />
        <meta
          name="twitter:description"
          content="Sreehari Diamond Laboratory is a trusted gemological lab in India offering expert diamond testing, certification, sealing, and hologram services."
        />
        <meta
          name="twitter:image"
          content="https://sreeharidiamondlab.com/static/media/About-Us.84214f9030191013ed4e.webp"
        />
        <meta name="twitter:site" content="sreehari diamond laboratory" />
        <link
          rel="canonical"
          href="https://sreeharidiamondlab.com/about-us"
        />{" "}
      </Helmet>
      <div>
        <AboutBanner />
        <AboutSummary />
      </div>
    </>
  );
};

export default AboutUs;
